import TPagination from './Pagination.vue'
import TNewPagination from './NewPagination.vue'

export const Pagination = TPagination
export const NewPagination = TNewPagination
